/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import Model from '@tripian/model';
import moment from 'moment';
import PoiInfoImageDesktop from './PoiInfoImage/PoiInfoImageDesktop/PoiInfoImageDesktop';
import PoiInfoImageMobile from './PoiInfoImage/PoiInfoImageMobile/PoiInfoImageMobile';
import PoiInfoText from './PoiInfoText/PoiInfoText';
import OfferCard from '../OfferCard/OfferCard';
import FavoriteIconButton from '../base/Button/Icons/FavoriteIconButton/FavoriteIconButton';
import ShareIconButton from '../base/Button/Icons/ShareIconButton/ShareIconButton';
import CloseIconButton from '../base/Button/Icons/CloseIconButton/CloseIconButton';
import { StarBlack } from '../base/Svg/Icons';
import ClockBlack from '../base/Svg/Icons/ClockBlack';
import OpenedHours from './OpenedHours/OpenedHours';
import PoiActionButton from './PoiActionButton/PoiActionButton';
import Modal from '../base/Modal/Modal';
import Button from '../base/Button/Button';
import BUTTON_TYPES from '../base/Button/ButtonTypes';
import SharePoiModal from '../SharePoiModal/SharePoiModal';
import classes from './PoiInfo.scss';

interface IPoiInfo {
  poi: Model.Poi;
  favorite: boolean;
  toggleFavorite: (poi: Model.Poi, willFavorite: boolean) => void;
  addRemoveReplacePoi: (poi: Model.Poi, removeReplaceAdd: number, from?: string, to?: string) => void;
  close: (poi: Model.Poi) => void;
  // Step attributes
  dayNumbers?: number[];
  stepOrder?: number;
  // Alternative
  replace?: boolean;
  hideActionButtons?: boolean;
  hideFavoriteIcon?: boolean;
  // hideScore?: boolean;
  hidePartOfDay?: boolean;
  hideFeatures?: boolean;
  hideCuisine?: boolean;
  planDate?: string;
  reservationButtonClick?: (productId: string, poi: Model.Poi) => void;
  favoriteLoading: boolean;
  reservationUrl?: string;
  hideBookingButton: boolean;
  square?: boolean;
  hideTours: boolean;
  getTourInfo?: (productId: string, poi: Model.Poi) => void;
  // TOUR_PROVIDER_IDS: Model.PROVIDER_ID[];
  // TICKET_PROVIDER_IDS: Model.PROVIDER_ID[];
  tourProducts: (Model.TourSearchProduct & { provider: string })[];
  ticketProducts: (Model.TourSearchProduct & { provider: string })[];
  tourTicketProductsLoading: boolean;
  RESTAURANT_RESERVATION_PROVIDER_IDS: Model.PROVIDER_ID[];
  myOffers: Model.Poi[];
  isLoadingOffer: (offerId: number) => boolean;
  offerButtonClick: (optIn: boolean, offer: Model.Offer, optInDate: string) => void;
  offerCardClicked?: () => void;
  hideOffers: boolean;
  // offerClicked?: boolean;
  loadingFeedback: boolean;
  feedbackSubjects: Model.FeedbackSubjects[];
  isBookingClicked: boolean;
  onBookableTabClick?: () => void;
  bookableProductsLoadingMore?: boolean;
  bookableProductsHasMore?: boolean;
  onLoadMoreBookableProducts?: () => void;
  timezone?: string;
  sendFeedback: (value: Model.FeedbackRequest) => Promise<void>;
  placeInfoCallBack: () => void;
  redeemClicked?: () => void;
  onImageModalChange?: (isOpen: boolean) => void;
  stepType?: string;
  t: (value: Model.TranslationKey) => string;
  // Timeline mode props
  plans?: Model.Plan[];
  currentDayIndex?: number;
  onTimelineAdd?: (planId: number, poiId: string, from?: string, to?: string) => void;
}

const PoiInfo: React.FC<IPoiInfo> = ({
  poi,
  favorite,
  toggleFavorite,
  close,
  addRemoveReplacePoi,
  dayNumbers,
  stepOrder = -1,
  replace = false,
  hideActionButtons = false,
  hideFavoriteIcon = false,
  hideFeatures = false,
  hideCuisine = false,
  reservationButtonClick,
  planDate,
  favoriteLoading,
  reservationUrl,
  hideBookingButton,
  square = true,
  hideTours,
  getTourInfo,
  tourProducts,
  ticketProducts,
  tourTicketProductsLoading,
  // TOUR_PROVIDER_IDS,
  // TICKET_PROVIDER_IDS,
  RESTAURANT_RESERVATION_PROVIDER_IDS,
  myOffers,
  isLoadingOffer,
  offerButtonClick,
  offerCardClicked,
  hideOffers,
  // offerClicked,
  loadingFeedback,
  feedbackSubjects,
  isBookingClicked,
  onBookableTabClick,
  bookableProductsLoadingMore,
  bookableProductsHasMore,
  onLoadMoreBookableProducts,
  timezone = 'UTC',
  sendFeedback,
  redeemClicked,
  onImageModalChange,
  stepType,
  t,
  plans,
  currentDayIndex,
  onTimelineAdd,
}) => {
  const [optInModalWarningMessage, setOptInModalWarningMessage] = useState<string[]>([]);
  const [showShareModal, setShowShareModal] = useState(false);

  const offerRef = React.createRef<HTMLDivElement>();

  moment.locale(window.twindow.langCode);

  let partOfDay = '';
  if (dayNumbers && dayNumbers.length !== 0) {
    partOfDay = dayNumbers.join(',');
  }

  return (
    <div className={classes.poiContainer}>
      <div className={classes.closeButton}>
        <CloseIconButton className="w-6 h-6" fill="#696969" clicked={() => close(poi)} />
      </div>
      <div className="hide-m">
        <PoiInfoImageMobile poi={poi} square={square} favorite={favorite} favoriteLoading={favoriteLoading} toggleFavorite={toggleFavorite} hideFavoriteIcon={hideFavoriteIcon} close={close} t={t} stepType={stepType} />
      </div>
      <div className={classes.poiInfo}>
        <div className={classes.header}>
          <h1 className={classes.title}>
            {poi.name}
            {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
            {(window as any).tconfig?.ELIGIBILITY_TYPE === 'visa' && poi.externalUrl && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(poi.externalUrl!, '_blank', 'noopener,noreferrer');
                }}
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '0.25rem', verticalAlign: 'middle', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                aria-label="External link"
              >
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */}
                <img src={(window as any).tconfig?.IMAGE_PATHS?.LOGO_PATH_LIGHT} alt="External link" style={{ height: '0.9rem', width: 'auto', objectFit: 'contain' }} />
              </button>
            )}
          </h1>

          <div className={classes.actions}>
            <ShareIconButton className={classes.shareIconButton} clicked={() => setShowShareModal(true)} />
            {!hideFavoriteIcon && (
              <FavoriteIconButton
                className={classes.favoriteIconButton}
                clicked={() => {
                  toggleFavorite(poi, !favorite);
                }}
                loading={favoriteLoading}
                favorite={favorite}
              />
            )}
            <div className="hide-s">
              <PoiActionButton poi={poi} hideActionButtons={hideActionButtons} replace={replace} stepOrder={stepOrder} addRemoveReplacePoi={addRemoveReplacePoi} partOfDay={partOfDay} t={t} plans={plans} currentDayIndex={currentDayIndex} onTimelineAdd={onTimelineAdd} />
            </div>
          </div>
        </div>
        <div className={classes.ratingPrice}>
          {poi.rating && poi.ratingCount && (
            <div className={classes.rating}>
              <StarBlack />
              <div>
                <span className={classes.score}>{poi.rating}</span>
                <span className={classes.reviews}>({poi.ratingCount})</span>
              </div>
            </div>
          )}

          {poi.price && (
            <>
              <div className={classes.dot} />
              <div className={classes.price}>
                <span className={classes.priceActive}>$$</span>
                <span className={classes.priceInactive}>$$</span>
              </div>
            </>
          )}
        </div>
        {poi.hours && (
          <div className={classes.status}>
            <div className={classes.statusInfo}>
              <ClockBlack />
            </div>

            <div className={classes.hours}>
              <OpenedHours hourStr={poi.hours || ''} planDate={planDate} timezone={timezone} t={t} />
            </div>
          </div>
        )}
        <div className={classes.content}>
          <div className={classes.gallery}>
            <PoiInfoImageDesktop poi={poi} onImageModalChange={onImageModalChange} t={t} stepType={stepType} />
          </div>
        </div>

        <PoiInfoText
          poi={poi}
          hideFeatures={hideFeatures}
          hideCuisine={hideCuisine}
          hideTours={hideTours}
          reservationUrl={reservationUrl}
          hideBookingButton={hideBookingButton}
          reservationButtonClick={reservationButtonClick}
          tourProducts={tourProducts}
          ticketProducts={ticketProducts}
          addRemoveReplacePoi={addRemoveReplacePoi}
          partOfDay={partOfDay}
          hideActionButtons={hideActionButtons}
          replace={replace}
          stepOrder={stepOrder}
          getTourInfo={getTourInfo}
          tourTicketProductsLoading={tourTicketProductsLoading}
          RESTAURANT_RESERVATION_PROVIDER_IDS={RESTAURANT_RESERVATION_PROVIDER_IDS}
          loadingFeedback={loadingFeedback}
          feedbackSubjects={feedbackSubjects}
          sendFeedback={sendFeedback}
          isBookingClicked={isBookingClicked}
          onBookableTabClick={onBookableTabClick}
          bookableProductsLoadingMore={bookableProductsLoadingMore}
          bookableProductsHasMore={bookableProductsHasMore}
          onLoadMoreBookableProducts={onLoadMoreBookableProducts}
          t={t}
          plans={plans}
          currentDayIndex={currentDayIndex}
          onTimelineAdd={onTimelineAdd}
        />

        {!hideOffers && poi.offers && poi.offers.length > 0 && (
          <div className="col col12 px5 pb5">
            {/* <h2 className="mb1 mt3">Offers</h2> */}
            {poi.offers.map((offer, i) => {
              const offerStartDate = moment(moment(offer.timeframe?.start).format('YYYY-MM-DD'));
              const offerEndDate = moment(moment(offer.timeframe?.end).format('YYYY-MM-DD'));
              const planDateTimeNow = moment(planDate);

              const canOptIn = planDateTimeNow.isBetween(offerStartDate, offerEndDate, undefined, '[]');
              const planDateTime: string = planDateTimeNow.format('YYYY-MM-DD');

              return (
                <div key={`offer-${i}`} ref={offerRef} className="py2">
                  <OfferCard
                    offer={offer}
                    optedIn={myOffers.some((p) => p.offers.some((x) => x.id === offer.id))}
                    isLoadingOffer={isLoadingOffer}
                    optClicked={(optIn: boolean, id: number, optInDate?: string) => {
                      if (canOptIn) offerButtonClick(optIn, offer, optInDate || planDateTime);
                      else setOptInModalWarningMessage([planDateTime, moment(offer.timeframe?.start).format('YYYY-MM-DD'), moment(offer.timeframe?.end).format('YYYY-MM-DD')]);
                    }}
                    cardClicked={offerCardClicked}
                    planDate={planDate}
                    redeemClicked={redeemClicked}
                  />
                </div>
              );
            })}
            <Modal show={optInModalWarningMessage.length > 0} backdropClick={() => setOptInModalWarningMessage([])}>
              <div className="center py5">
                <h2 className="folt-bold">{t('trips.myTrips.itinerary.step.poi.warning.title')}</h2>
                <div className="m2">
                  {t('trips.myTrips.itinerary.step.poi.warning.message1')} {optInModalWarningMessage[0]}.
                </div>
                <div className="m2">
                  {t('trips.myTrips.itinerary.step.poi.warning.message2')} {optInModalWarningMessage[1]} {t('trips.myTrips.itinerary.step.poi.warning.and')} {optInModalWarningMessage[2]}.
                </div>
                <div className="mt2 mb3">{t('trips.myTrips.itinerary.step.poi.warning.message3')}</div>
                <Button size="small" type={BUTTON_TYPES.OUTLINED} text="Ok" onClick={() => setOptInModalWarningMessage([])} />
              </div>
            </Modal>
          </div>
        )}

        {showShareModal && <SharePoiModal poiName={poi.name} poiId={poi.id} onCancel={() => setShowShareModal(false)} t={t} />}
      </div>
    </div>
  );
};

export default PoiInfo;
